var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gridCtl",class:_vm.type,style:(_vm.extendStyle),attrs:{"id":_vm.id}},[_c('div',{staticClass:"goGridObj no-border",attrs:{"id":_vm.gridId}})])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/go-tree-grid.vue